import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm';
import { Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'

export default function RateSnapShot() {
    const [lgShow, setLgShow] = useState(false);
    const [accessType, setAccessType] = useState('')

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);

        if (foundUser.role_capabilities?.all_modules_access === true) {

            setAccessType('Edit');

        }
        else {

            setAccessType(foundUser.access['RateSnapshot_Access Specifier']);
        }

    }, []);

    return (
        <>

            <div className="row">
                <div className="row my-3 ">
                    <div className="col-md-6">
                        <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
                            Rate Snapshot {accessType === 'View' && "/ View Only Mode"}
                        </Typography>
                    </div>

                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
                        <Modal
                            size="lg"
                            show={lgShow}
                            onHide={() => setLgShow(false)}
                            aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                                <Modal.Title id="example-modal-sizes-title-lg" >
                                    Instructions for Rate Snapshot
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <h5>To View Rates</h5>
                                <ol>
                                    <li>Select  Account Name from the dropdown</li>
                                    <li>Select Location Name from the dropdown</li>
                                    <li>Select Rate Code</li>
                                    <li>Select From Date from the Calendar</li>
                                    <li>Select Number of days snapshot from the dropdown</li>
                                    <li>Select Rate Plan from the dropdown</li>
                                    <li>Click on Preload button to view the rate plan for the selected date</li>
                                </ol>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>

            {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}
        </>
    );
}